export const dateFormatter = (dateString) => {
  // const months = [
  //   'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  //   'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
  // ];

  const months = [
    'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Ags.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'
  ];

  const date = new Date(dateString);

  if (isNaN(date)) return 'Tanggal tidak valid';

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return `${day} ${months[monthIndex]} ${year}`;
};
